import { keysToCompare } from "./enums";
import _ from "lodash";

export const areEquals = (currentState: Dic<any>, serverState: Dic<any>) => {
  return keysToCompare.every((key: string) =>
    _.isEqual(currentState[key], serverState[key])
  );
};

export const areEqualsJson = (
  currentState: Dic<any>,
  serverState: Dic<any>
) => {
  const keys1 = Object.keys(currentState);
  const keys2 = Object.keys(serverState);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let i = 0; i < keys1.length; i++) {
    if (keys1[i] !== keys2[i]) {
      return false;
    }
  }

  return areEquals(currentState, serverState);
};
